/* Tote — transparent header across the whole store.
   Every page: header sits transparent over the page, then adds .tote-nav-solid
   to <body> once scrolled so it's readable over content.
   Pages that OPEN with a full-bleed tote-hero also pull the hero up behind the
   header so it floats over the image. */
(function () {
  function init() {
    var main = document.getElementById('MainContent');
    if (!main) return;

    // Transparent frosted header on ALL pages: tag the header-group sections
    // (announcement + header) that sit above <main>.
    var el = main.previousElementSibling;
    while (el) {
      if (el.nodeType === 1) el.classList.add('tote-topbar');
      el = el.previousElementSibling;
    }

    // Overlay pull-up ONLY when the first section is a full-bleed banner
    // (tote-hero or tote-promo) — so other pages never hide content.
    var firstSection = main.querySelector('[id^="shopify-section"]');
    var startsWithHero = !!(firstSection && firstSection.querySelector('[data-tt-hero], .tt-promo'));
    if (startsWithHero) {
      var overlay = function () {
        main.style.marginTop = '0px';
        var top = main.getBoundingClientRect().top + window.pageYOffset;
        main.style.marginTop = (-top) + 'px';
      };
      overlay();
      window.addEventListener('resize', overlay);
      if ('ResizeObserver' in window) {
        try { new ResizeObserver(overlay).observe(document.body); } catch (e) {}
      }
    }

    // Solidify the bar after scrolling away from the very top — ALL pages.
    function solid() {
      document.body.classList.toggle('tote-nav-solid', window.pageYOffset > 60);
    }
    solid();
    window.addEventListener('scroll', solid, { passive: true });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
